import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" }
const _hoisted_2 = { class: "bg-white p-6 rounded-lg w-11/12 md:w-3/4 max-h-[90vh] relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 19l-7-7m0 0l7-7m-7 7h18"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "mt-8 max-h-[calc(90vh-8rem)] overflow-y-auto px-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-4" }, "Historial de seguimiento", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-5 gap-4 mb-4 px-4 font-semibold text-sm text-gray-700 bg-white sticky top-0 z-10" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Etapa"),
  /*#__PURE__*/_createElementVNode("div", null, "Asignado"),
  /*#__PURE__*/_createElementVNode("div", null, "Fecha"),
  /*#__PURE__*/_createElementVNode("div", null, "Completada"),
  /*#__PURE__*/_createElementVNode("div", null, "Razón de rechazo")
], -1)
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "grid grid-cols-5 gap-4 px-4 py-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200" }
const _hoisted_10 = { class: "text-gray-600 whitespace-pre-wrap" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-full"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-16 w-16 text-gray-400 mb-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl text-gray-600 font-medium" }, "No hay historial disponible", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mt-2" }, "No se encontraron registros de seguimiento para esta tarea", -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]

import { onMounted, onUnmounted } from 'vue';
import type ITask from '@/interfaces/ITask';
import ApiService from '@/services/ApiService';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskDetail',
  props: {
    task: {},
    userData: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props;



const apiService = new ApiService();
const taskHistory = apiService.getDetailTask()

onMounted(async () => {
    document.body.style.overflow = 'hidden';
    if (props.task.processBaseReference) {
        await apiService.fetchTaskDetail(props.userData, props.task.processBaseReference);
    }
});

onUnmounted(() => {
    document.body.style.overflow = 'auto';
});

const formatFecha = (date: string | null) => {
    if (!date || date === "0001-01-01T00:00:00") return "-";
    const fecha = new Date(date);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "absolute top-4 left-4 text-gray-600 hover:text-gray-800",
        title: "Volver"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_unref(taskHistory) && _unref(taskHistory).length > 0 && _unref(taskHistory)[0].values && _unref(taskHistory)[0].values[0].elements && _unref(taskHistory)[0].values[0].elements.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskHistory), (element) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: element.id
                  }, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.values, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: value.internalName
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.elements, (historyLine) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: historyLine.id,
                              class: "mb-4"
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyLine.values, (historyElement) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: historyElement.internalName,
                                    class: "text-sm break-words overflow-y-auto max-h-32"
                                  }, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(historyElement.valueType === 'Date' ? formatFecha(historyElement.value) : (historyElement.value || '-')), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
      ])
    ])
  ]))
}
}

})